import { SelectUserAndGroupForCommunications } from "./SelectUserAndGroupForCommunications.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
// src/modules/Users/shared/FormikSelectUserAndGroupForCommunications.tsx
var FormikSelectUserAndGroupForCommunications = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => {
			return /* @__PURE__ */ jsx(SelectUserAndGroupForCommunications, {
				...props,
				error: meta.touched && meta.error,
				valid: meta.touched && meta.value && !meta.error,
				onChangeValue: (value) => props.name && form.setFieldValue(props.name, value),
				...field,
				onChange: null
			});
		}
	});
};
export { FormikSelectUserAndGroupForCommunications };

//# sourceMappingURL=FormikSelectUserAndGroupForCommunications.js.map